import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useEntityHistory(entityType: string, entityId: string) {
  return useQuery({
    queryKey: ['entity-history', entityType, entityId],
    queryFn: async () => {
      const { data } = await api.get(`/loans/${entityId}/changes`);
      return data;
    },
    enabled: !!entityId,
  });
}

export function useRecentChanges(limit?: number) {
  return useQuery({
    queryKey: ['recent-changes', limit],
    queryFn: async () => {
      const params = limit ? `?limit=${limit}` : '';
      const { data } = await api.get(`/tracking/changes/recent${params}`);
      return data;
    },
  });
}

export function useUserChanges(userId: string) {
  return useQuery({
    queryKey: ['user-changes', userId],
    queryFn: async () => {
      const { data } = await api.get(`/tracking/changes/by-user/${userId}`);
      return data;
    },
    enabled: !!userId,
  });
}
